import { Record as ImmutableRecord } from 'immutable';
import type { RecordOf } from 'immutable';

import { WS_GRID_DEFAULT_PRESET_ID } from '@/domain/documents/constants';
import type { GridLayout } from '@/domain/documents/gridPreset/schemas';
import type { SavedColumnLayout } from '@/domain/documents/savedColumnLayout';

export type GridPresetState = {
  // The company the layout belongs to; null until resolved. The grid renders only when it equals the route's.
  companyId: string | null;
  presetId: string;
  sharedPresetId: string | null;
  // `saved` and `current` are plain JS (AG Grid shapes); null until resolved. `saved` is the preset as stored, with the
  // parts about columns this grid does not have (an "(all)" preset saved under another ERP); `current` holds only
  // this grid's part (`layoutInGrid`).
  saved: GridLayout | null;
  current: GridLayout | null;
  // Bumped only by external changes; the grid applies `current` when it changes.
  revision: number;
  // Default's columns from the column definitions (LTR).
  defaultColumns: SavedColumnLayout;
  // Whether the layout may be stored. False while it is a fallback the user did not choose (the presets list failed
  // to load): the stored choice must survive for the next load, whatever follows — automatic updates or the user's
  // edits. Choosing or saving a preset is the user's own choice and makes it storable again.
  persistable: boolean;
};

export const GridPresetStateFactory = ImmutableRecord<GridPresetState>({
  companyId: null,
  presetId: WS_GRID_DEFAULT_PRESET_ID,
  sharedPresetId: null,
  saved: null,
  current: null,
  revision: 0,
  defaultColumns: [],
  persistable: false,
});

export type GridPresetStateRecord = RecordOf<GridPresetState>;
